export type { AlsoAvailableOnModalProps } from './AlsoAvailableOnModal';
export { AlsoAvailableOnModal } from './AlsoAvailableOnModal';
